<template>
  <div>
    <div
      class="deleted"
      v-if="options.checkDelete && data[options.checkDelete]"
    >
      <span> DELETED </span>
    </div>
    <span
      :class="options.class"
      @click="$parent.$parent.$parent.deleteFunction(deletedData)"
      style="cursor:pointer"
      v-role="roles"
      v-else>
      <i class="ag-icon ag-icon_delete" data-toggle="tooltip" title="Delete"></i>
    </span>
  </div>
</template>

<script>
import { Roles } from "@/helpers/enums/Roles";

export default {
  name: "tableDeleteComponent",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  computed: {
    roles() {
      return this.options.roles
        ? this.options.roles
        : [
            Roles.AGMSAdmin,
            Roles.PartnerAdmin,
            Roles.GroupAdmin,
            Roles.GroupAudit,
            Roles.CompanyAdmin,
            Roles.SiteAdmin,
            Roles.SiteAudit,
          ];
    },
    deletedData() {
      if (this.options.idField) {
        return this.data[this.options.idField];
      }
      return this.data.id;
    },
  },
};
</script>

<style scoped>
.deleted span {
  color: #faa7a7;
}
</style>
